import ContactInfoDialog from "./ContactInfoDialog";

export default ContactInfoDialog;
